import React from "react";
import { Button } from "./ui";
import { X } from "lucide-react";

export default function LeadDetailsModal({ lead, isOpen, onClose }) {
  if (!isOpen || !lead) return null;

  return (
    <div className="modal">
      <div className="modal-content modal-details">
        <div className="modal-header">
          <div className="title">Lead Details</div>
          <Button variant="outline" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="lead-details-body">
          <div className="details-section">
            <div className="section-header">Lead Information</div>
            <div className="details-grid">
              <div className="detail-row">
                <span className="detail-label">Date:</span>
                <span className="detail-value">{new Date(lead.created_at).toLocaleString()}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Lead Maker:</span>
                <span className="detail-value">{lead.leadmaker_name || lead.leadmaker_id.slice(0, 8)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Segment:</span>
                <span className="detail-value">{lead.customer?.customer_segment}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Status:</span>
                <span className={`detail-value status-badge status-${lead.status}`}>{lead.status}</span>
              </div>
            </div>
          </div>

          <div className="details-section">
            <div className="section-header">Customer Information</div>
            <div className="details-grid">
              <div className="detail-row">
                <span className="detail-label">Name:</span>
                <span className="detail-value">{lead.customer?.name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Phone:</span>
                <span className="detail-value">{lead.customer?.phone_number}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Email:</span>
                <span className="detail-value">{lead.customer?.email}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Address:</span>
                <span className="detail-value">{lead.customer?.delivery_address}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">City:</span>
                <span className="detail-value">{lead.customer?.city}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">District:</span>
                <span className="detail-value">{lead.customer?.district}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">State:</span>
                <span className="detail-value">{lead.customer?.state}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Area Code:</span>
                <span className="detail-value">{lead.customer?.area_code}</span>
              </div>
            </div>
          </div>

          <div className="details-section">
            <div className="section-header">Products</div>
            <div className="products-table-wrapper">
              <table className="products-table">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {lead.products && lead.products.length > 0 ? (
                    lead.products.map((p, i) => (
                      <tr key={i}>
                        <td>{p.product_name}</td>
                        <td>₹{(parseFloat(p.price) || 0).toFixed(2)}</td>
                        <td>{p.quantity}</td>
                        <td>₹{(parseFloat(p.total_sale_value) || (parseFloat(p.price) * parseInt(p.quantity))).toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center' }}>No products</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="details-section">
            <div className="section-header">Summary</div>
            <div className="details-grid">
              <div className="detail-row summary-row">
                <span className="detail-label">Total Value:</span>
                <span className="detail-value summary-value">₹{(parseFloat(lead.total_value) || 0).toFixed(2)}</span>
              </div>
              <div className="detail-row summary-row">
                <span className="detail-label">Commission Amount:</span>
                <span className="detail-value summary-value">₹{(parseFloat(lead.commission_amount) || 0).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
